import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setSearchQuery } from '../actions'

class Searchbar extends Component {

  saveSearchQuery = (value) => {
    //this.props.actions.setSearchQuery(value)
    this.props.onSearch(value)
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.saveSearchQuery(this.refs.input.value)
    }
  };

  render() {
    return (
      <label className="axiom-textfield-input-label">
        <span className="axiom-textfield-icon-left">
          <input
            ref='input'
            onKeyPress={this.handleKeyPress}
            placeholder="Search"
            className="axiom-textfield-input"
            type="search"
            style={{ width: '400px'}}
          />
          <i className="axiom-icon-icon icon-search"></i>
        </span>
      </label>
    )
  }
}

function mapStateToProps(state) {
  const { searchbar } = state
  return { searchbar }
}

function mapDispatchToProps(dispatch) {
  const actions = { setSearchQuery }
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Searchbar)